import React from 'react';
import Nanvbarm from './NavBarM'
import Container from 'react-bootstrap/Container'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Form from 'react-bootstrap/Form'
import InputGroup from 'react-bootstrap/InputGroup'
import MuiTable from './MuiTable'

class InstallerMain extends React.Component{
    constructor(props){
        super();
        this.state = {
            data:[],
            open:false,
            selected: {
                status: 3,
                type: -1,
                search:''
            },
            userRole:localStorage.getItem('role')
        }
       
    }
    setOpen(arg){
        this.setState({
            open: arg
          });
    }
    changeType(e,event){
        this.setState({
            selected: {
                ...this.state.selected,
                type: event.target.value

            }
        })
    }

    changeStatus(e,event){
        this.setState({
            selected: {
                ...this.state.selected,
                status: event.target.value
            }
        })
    }

    changeSearch(e,event){
        this.setState({
            selected: {
                ...this.state.selected,
                search: event.target.value
            }
        })
    }
    render(){
        return (
            <div ref={this.wrapper}>
                <Nanvbarm user = {0}/>
                <Container className='row-content px-3' ref={this.wrapper} fluid>
                    <Row>
                        <Col sm={4}>
                            <InputGroup className="mb-4">
                                <InputGroup.Prepend>
                                    <InputGroup.Text id="basic-addon1">სტატუსი</InputGroup.Text>
                                </InputGroup.Prepend>
                                <Form.Control as="select"  onChange={(event)=>this.changeStatus(this,event)}>
                                    <option value={3}>გახსნილი</option>
                                    <option value={1}>მიმდინარე</option>
                                </Form.Control>
                            </InputGroup>
                        </Col>
                    </Row>
                </Container>
                <Container  fluid>
                    <Row>
                        <MuiTable 
                            title = "დავალებები" 
                            type = {this.state.selected.type} 
                            status = {this.state.selected.status} 
                            search = {this.state.selected.search}
                            role = {this.state.userRole}
                        />
                    </Row>
                </Container>
            </div>
        )
    }
}
export default InstallerMain;